import React, { useState } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './App.css';
import 'materialize-css/dist/css/materialize.css';
import 'materialize-css/dist/js/materialize';
import "font-awesome/css/font-awesome.css";
import 'react-notifications-component/dist/theme.css'

// import Login from './pages/auth/login';
import LoginContainer from './containers/login';
import RegisterContainer from './containers/register';

import Register from './pages/auth/register';
import Check from './pages/assessment/check';
import Wellcome from './pages/survey/wellcome';
import Result from './pages/survey/result';
import SelectOpration from './pages/selectOpration';
import ForgotPassword from './containers/forgot-password';
import ResetPassword from './containers/resetPassword';
import AppLayout from './components/appLayout';
import Home from './pages/app/home';
import Profile from './containers/profile';
import QRScanner from './pages/app/qr-scanner';
import Test from './pages/test';
import History from './containers/history';
import AassessmentHistory from './pages/survey/history';
import LodingContainer from "./containers/loading"
import ReactNotification from 'react-notifications-component'
import confirmCodeContainer from './containers/confirmCode';
import surveyContainer from './containers/survey';
import authService from "./services/authService";
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import AddToHomescreen from "react-add-to-homescreen"

function App() {
  const handleAddToHomescreen = () => {
    alert('1. Open Share menu\n2. Tap on "Add to Home Screen" button');
  };

  return (
    <BrowserRouter>
      <LodingContainer />
      <ReactNotification />
      <Switch>
        <Route exact path={["/", "/selectOpration"]} component={SelectOpration} />
        <Route exact path="/auth/login" render={props => authService.isValidNormal() ? <Redirect to="/app" /> : <LoginContainer {...props} /> } />
        <Route exact path="/auth/register" render={props => authService.isValidNormal() ? <Redirect to="/app" /> : <RegisterContainer {...props} /> } />
        <Route exact path="/auth/register/confirm" component={confirmCodeContainer} />

        <Route exact path="/auth/forgat-password" component={ForgotPassword} />
        <Route exact path="/auth/reset-password" component={ResetPassword} />
        <Route exact path="/auth/recovery/login" component={Register} />

        <Route exact path={["/survey/wellcome", "/survey", "/survey/result/:type", "/survey/check", "/survey/history"]}>
            <Switch>
              <Route exact path="/survey/wellcome" component={Wellcome} />
              <Route exact path="/survey" component={surveyContainer} />
              <Route exact path="/survey/result/:type" component={Result} />
              <Route exact path="/survey/check" component={Check} />
              <Route exact path="/survey/history" component={AassessmentHistory} />
            </Switch>
        </Route>
        {authService.isValidNormal ? <Route exact path={["/app", "/app/home", "/app/profile", "/app/qr", "/app/history"]}>
          <AppLayout>
            <Switch>
              <Route exact path="/app/home" component={Home} />
              <Route exact path="/app/profile" component={Profile} />
              <Route exact path={["/app", "/app/qr"]} component={QRScanner} />
              <Route exact path="/app/history" component={History} />
            </Switch>
          </AppLayout>
        </Route> : <Redirect to="/auth/login" />}

        <Route exact path="/test" component={Test} />

      </Switch>
      <AddToHomescreen onAddToHomescreenClick={handleAddToHomescreen}/>
    </BrowserRouter>
  );
}

export default App;
